import { h } from "preact";

export default function ProductOptionWaitlistButton({
  variant,
  optionValueName,
}) {
  const variantId = variant.id.replace("gid://shopify/ProductVariant/", "");
  const variantUrl = `${variant.product.helpers.url}?variant=${variantId}`;

  return (
    <back-in-stock-button SELECTED-VARIANT={variantId} URL={variantUrl}>
      <button
        type="button"
        class="product-options__swatch-tooltip-cta bis-button"
        data-bis-button
      >
        {window.localeStrings.product.option_notify_me.replace(
          "[option]",
          optionValueName,
        )}
      </button>
    </back-in-stock-button>
  );
}
